import { render, staticRenderFns } from "./IndicatorScore.vue?vue&type=template&id=046305a4&scoped=true&"
import script from "./IndicatorScore.vue?vue&type=script&lang=js&"
export * from "./IndicatorScore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046305a4",
  null
  
)

export default component.exports